import { gql } from '@apollo/client';

export const REPHRASE_TEXT_MUTATION = gql`
  mutation rephraseText(
    $organizationId: String!
    $config: ContentGenerationInput!
  ) {
    rephraseText(organizationId: $organizationId, config: $config) {
      ... on TextGenerated {
        suggestions {
          content
        }
      }
      ... on CommonError {
        code
        success
        message
        error
      }
    }
  }
`;
